<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <p class="navbar-brand" style="margin-bottom:10px;">
        <!--<img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">-->
        <span>Plataforma Educativa 4.0</span>
      </p>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <!--<b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item>
      </b-navbar-nav>-->
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownAccnt class />
        </b-nav-item>
        <b-nav-item class="d-md-down-none"></b-nav-item>
      </b-navbar-nav>
      <AsideToggler class="d-none" />
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <!--<ul class="nav">
          <li class="nav-item">
            <a class="router-link-exact-active open active nav-link">
              <i class="nav-icon icon-home fa-3x" style="font-size: 32px;"></i>
              <span style="margin-left: 15px;">Inicio</span>
            </a>
          </li>
        </ul>-->
        <SidebarFooter />
      </AppSidebar>
      <main class="main">
        <!--
        <Breadcrumb :list="list" disabled/>
        -->
        <br />

        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside v-if="$route.name == ''" />
        <ConstructorAside
          v-else-if="$route.name == 'Nuevo' || $route.name == 'Preview' || $route.name == 'Editar Material'"
        />
        <DefaultAside v-else />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <!-- CME -->
        <span class="ml-1"></span>
      </div>
      <div class="ml-auto">
        <span class="mr-1"></span>
        <a href="#"></a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import ConstructorAside from "@/components/ConstructorAside";
import DirectorioService from "@/services/directorio.service";
import LicenciaService from "@/services/licencia.service";
import {
  sidebarCssClasses,
  asideMenuCssClasses,
  validBreakpoints,
  checkBreakpoint
} from "@coreui/vue/src/shared/classes";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    ConstructorAside
  },
  data() {
    return {
      nav: nav.items,      
      materias: new Array()
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    clave() {
      return this.$route.author;
    }
  },
  beforeCreate() {
    this.user = this.$store.getters["auth/infoUser"];
    console.log(this.user);
    var author = this.user._id;
    
    LicenciaService.clave(this.user._id).then(result => {
      //console.log(result.success);
      this.directorios = result.success;
      this.$store.dispatch("directorio/setCursos", this.directorios);
      var sorted = this.directorios.sort((a, b) =>
        a.orden > b.orden ? 1 : -1
      );
      nav.items[3].children = [];
      sorted.forEach(m => {
        nav.items[3].children.push({
          name: m.name,
          url: `/cme/cursos/${m.name}`,
          icon: "icon-folder-alt"
        });
      });
    });

    //var cursosHabilitados = [];

    /*DirectorioService.list(1,{filtro: {principal:true }}).then(response => {

      /*response.forEach(el => {
        //console.log(el);
        if(arryCursosId.includes(el._id)){
          cursosHabilitados.push(el);
        }
      });

      console.log(cursosHabilitados);

      this.directorios = cursosHabilitados;
      this.$store.dispatch('directorio/setCursos',this.directorios);
      var sorted = this.directorios.sort((a,b) => (a.orden > b.orden) ? 1: -1);
      sorted.forEach(m => {
        nav.items[3].children.push({
          name: m.name,
          url: `/cme/cursos/${m.name}`,
          icon: 'icon-folder-alt'
        });
      });
      
    })*/
  }
};
</script>

<style>
.hde {
  width: 0px;
  display: none;
}
</style>